import { createStore, applyMiddleware, compose } from "redux";
import { browserHistory } from "react-router";
import { routerMiddleware as createRouterMiddleware } from "react-router-redux";
import thunkMiddleware from "redux-thunk";
import { createEpicMiddleware } from "redux-observable";
import createRavenMiddleware from "raven-for-redux";
import { cloneDeepWith, mapValues } from "lodash";

import errorMiddleware from "./errorMiddleware";
import RootReducer from "../RootReducer";
import RootEpic from "../RootEpic";

const shallowClone = (data) =>
  cloneDeepWith(data, (value, key, object, stack) => {
    if (value && typeof value === "object" && stack && stack.size > 150) {
      return "[FILTERED]";
    }
    if (Array.isArray(value) && value.length > 25) {
      return "[FILTERED]";
    }
    if (value && typeof value === "object" && value.uuid && value.type) {
      // Skip nested objects
      return mapValues(value, (v) => {
        if (v && typeof v === "object") {
          return "[FILTERED]";
        } else {
          return v;
        }
      });
    }
  });

const routerMiddleware = createRouterMiddleware(browserHistory);
const epicMiddleware = createEpicMiddleware(RootEpic);
const ravenMiddleware = createRavenMiddleware(window.Raven, {
  // We cant send it because of Request Entity Too Large bug ;/
  // (https://github.com/getsentry/raven-js/issues/874)
  stateTransformer: shallowClone,
  actionTransformer: shallowClone,
});
const middlewares = [errorMiddleware, routerMiddleware, ravenMiddleware, thunkMiddleware, epicMiddleware];

const enhancer = compose(applyMiddleware(...middlewares))(createStore);

export default function configureStore(initialState) {
  return enhancer(RootReducer, initialState);
}



// WEBPACK FOOTER //
// ./src/app/store/configureStore.build.js